import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BsFacebook } from "react-icons/bs";
import { ImGooglePlus } from "react-icons/im";
import { useForm } from "react-hook-form";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import app from './firebase.init';
import isValidEmail from "../../utils/isValidEmail";
// import isValidPassword from "../../utils/isValidPassword";
import { toast } from 'react-toastify';
import LoginWithGoogle from './LoginWithGoogle';
import LoginWithFacebook from './LoginWithFacebook';
import { useDispatch, useSelector } from 'react-redux';
import { setAccessToken, setUserInfo } from '../../features/user/userSlice';
import { useCreateTokenMutation } from '../../features/api/apiSlice';

const Login = () => {
    // const  mutation  = useSelector(state => state.user);
    const [createToken, { data: token, isError, isSuccess }] = useCreateTokenMutation();
    const { accessToken } = useSelector(state => state.user);
    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    const dispatch = useDispatch();
    let navigate = useNavigate();
    let location = useLocation();


    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    let { from } = location.state || { from: { pathname: "/" } };

    const { register, handleSubmit, formState: { errors } } = useForm();

    const auth = getAuth(app);
    const onSubmit = async data => {
        const email = data.email;
        const password = data.password;
        if (!isValidEmail(email)) {
            return toast.error(`${translate ? 'Email is not valid': 'ইমেইল টি সঠিক নয়'}`, {
                position: "bottom-left",
            });
        }
        else if (password.length < 6) {
            return toast.error(`${translate ? "weak-password: Password should be at least 6 characters " : 'দুর্ভল পাসওয়ার্ড: পাসওয়ার্ড কম্পক্ষে ৬ সংখ্যার হতে হবে।'}`, {
                position: "bottom-left",
            });
        }
        else {
            await signInWithEmailAndPassword(auth, email, password)
                .then((userCredential) => {
                    const user = userCredential.user;
                    if (user) {
                        // createToken(email, user.uid)
                        createToken({ email: email, uid: user.uid })
                        toast.success("Your Login Successfully", {
                            position: "bottom-left",
                        });
                        dispatch(setUserInfo(user));

                    }
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    if (error) {
                        toast.error(`${errorMessage}`, {
                            position: "bottom-left",
                        });
                    }
                });

        }
    };

    useEffect(() => {
        if(isSuccess || accessToken){
            navigate(from);
        }
    }, [isSuccess, navigate, accessToken]);

    return (
        <div>
            <div className="flex justify-center">
                <div className="grid grid-cols-3 lg:w-4/6 w-full h-full p-3">
                    <div className="col-span-2">
                        <h2 onClick={createToken} className="text-xl font-medium text-gray-700 font-poppins">{translate ? "Welcome to Deer Perfume! Please login." : "Deer Perfume এ স্বাগতম! দয়া করে লগইন করুন."} </h2>
                    </div>
                    <div className="col-span-1 text-end">
                        <p className='text-sm text-gray-500'>{translate ? "New member?" : "নতুন সদস্য ?"}  <Link to="register"><span className='text-blue-700 cursor-pointer'>{translate ? "Register" : " এখানে নিবন্ধন"}</span></Link> {translate ? "here." : "করুন"}</p>
                    </div>
                </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="flex justify-center">
                    <div className="grid grid-cols-2 md:gap-12 shadow lg:w-4/6 w-full h-full bg-white p-4 pb-5">

                        <div className="md:col-span-1 col-span-2">
                            <div className='mb-4 '>
                                <label className="block text-sm font-normal text-gray-600 mb-0">
                                    {translate ? "Email Address*" : "ইমেইল ঠিকানা*"}
                                </label>
                                <input
                                    type="email"
                                    placeholder={translate ? "Please enter your Email" : "আপনার ইমেল ঠিকানা লিখুন দয়া করে"}
                                    name="email"
                                    {...register("email", { required: true })}
                                    className="h-9 focus:outline-offset-2  outline-blue-500/50 text-gray-600 my-1 border border-gray-400 w-full py-3 px-2 focus:outline-none font-poppins"

                                />
                                {errors.email && <span className='text-red-600'>{translate ? "This field is required" : "ঘরটি অবশ্যই পূরণ করতে হবে"}</span>}
                            </div>
                            <div className="">
                                <label className="block text-sm font-normal text-gray-600 mb-0">
                                    {translate ? "Password*" : "পাসওয়ার্ড*"}
                                </label>
                                <input
                                    // type="password"
                                    placeholder={translate ? "Please enter your password" : "আপনার পাসওয়ার্ড দিন"}
                                    name="email"
                                    {...register("password", { required: true })}
                                    className="h-9 focus:outline-offset-2  outline-blue-500/50 text-gray-600 my-1 border border-gray-400 w-full py-3 px-2 focus:outline-none font-poppins"

                                />
                                {errors.password && <span className='text-red-600'>{translate ? "This field is required" : "ঘরটি অবশ্যই পূরণ করতে হবে"}</span>}
                            </div>
                            <Link to="/auth/forget-password">
                                <p className='text-sm text-end text-blue-600 py-2.5'>{translate ? "Forgot Password?" : "পাসওয়ার্ড ভুলে গেছেন?"}</p>
                            </Link>                        </div>
                        <div className="md:col-span-1 col-span-2">
                            <button className="w-full py-[13px] my-1.5 rounded text-white bg-bnd-1 font-poppins">{translate ? "LOGIN" : "লগইন"} </button>
                            <p className="text-sm text-gray-500 py-1">{translate ? "Or, login with" : "অথবা, এগুলো দিয়ে লগইন করুন"}</p>
                            <LoginWithFacebook />
                            <LoginWithGoogle />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Login;